buildRootValueFromCache